module.exports = __webpack_public_path__ + "img/adock.beta.gouv.fr-50.e4395b95.png";